import { render } from "./jobBasicInfo.vue?vue&type=template&id=0ce04b1b&scoped=true&ts=true&lang=pug"
import script from "./jobBasicInfo.vue?vue&type=script&lang=ts"
export * from "./jobBasicInfo.vue?vue&type=script&lang=ts"

import "./jobBasicInfo.vue?vue&type=style&index=0&id=0ce04b1b&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce04b1b"]])

export default __exports__